import React from 'react';
import globalStyles from '../../utils/globalStyles';
import { Box, Typography, TextField, MenuItem, Select, Grid, BottomNavigationAction, BottomNavigation, Snackbar, Alert, TableContainer, Table, TableHead, Paper, TableBody, TableRow } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import 'bootstrap/dist/css/bootstrap.min.css';
import elrondApi from '../../api/elrond';
import axios from 'axios';
import legolasApi from '../../api/legolas';
const inputlabelstyle = {
    marginTop: '10px',
    marginBottom: '0px',
    marginLeft: '5px'
};
let feelabel = {};
let errormessage = {};

function NextdayConfiguration(props) {
    const formField = {
        enablePaymentFee: '',
        feelabelen: '',
        feevalue: '',
        minpayment: '',
        feetype: '',
        feelabelar: '',
        countryname: '',
        maxpayment: '',
        errormsgen: '',
        errormsgar: ''
    };
    const errorField = {
        enablePaymentFee: false,
        feelabelen: false,
        feevalue: false,
        minpayment: false,
        feetype: false,
        feelabelar: false,
        countryname: false,
        maxpayment: false,
        errormsgen: false,
        errormsgar: false
    }
    const [countryList, setCountryList] = React.useState([]);
    const [errormsg, setErrormsg] = React.useState(errorField);
    const { control } = useForm();
    const [formData, setFormData] = React.useState({});

    const validateForm = () => {
        if (![0, 1].includes(formData.enablePaymentFee)) {
            setErrormsg({ ...errormsg, enablePaymentFee: true });
            return false;
        }
        else if (!formData.feelabelen) {
            setErrormsg({ ...errormsg, feelabelen: true });
            return false;
        } else if (!formData.feelabelar) {
            setErrormsg({ ...errormsg, feelabelar: true });
            return false;
        } else if (!formData.feevalue) {
            setErrormsg({ ...errormsg, feevalue: true })
            return false;
        } else if (!formData.countryname) {
            setErrormsg({ ...errormsg, countryname: true });
            return false;
        } else if (!formData.errormsgen) {
            setErrormsg({ ...errormsg, errormsgen: true });
            return false;
        }
        else if (!formData.errormsgar) {
            setErrormsg({ ...errormsg, errormsgar: true });
            return false;
        }
        setErrormsg(errorField);
        return true;
    };

    const handlechange = (event) => {
        let { name, value } = event.target
        if (["enablePaymentFee", "enableFreeDelivery", "countryname", "feevalue", "minpayment", "maxpayment,freeDeliveryMinAmount"].includes(name)
        ) {
            value = value === "" ? "" : Number(value);
        }
        if (name === "enablePaymentFee") {
            setFormData({ ...formData, enablePaymentFee: value, enableFreeDelivery: value });
            return;
        }
        if (name === "enablePaymentFee") {
            setFormData({
                ...formData,
                enablePaymentFee: value,
                enableFreeDelivery: value
            });
            return;
        }
        if (name === 'feelabelen') {
            feelabel['en-SA'] = value
        }
        if (name === "feelabelar") {
            feelabel['ar-SA'] = value
        }
        if (name === 'errormsgen') {
            errormessage['en-SA'] = value
        }
        if (name === 'errormsgar') {
            errormessage['ar-SA'] = value
        }
        setFormData({ ...formData, [name]: value })
    };
    const getSessionId = () => {
        const username = localStorage.getItem('user');
        const data = JSON.parse(username);
        const session_id = (data.id).toString();
        return session_id;
    };

    const createSavePayload = () => {
        return {
            paymentId: props.paymentMethod,
            channelId: props.channelId,
            enablePaymentFee: formData.enablePaymentFee,
            enableFreeDelivery: formData.enableFreeDelivery !== undefined ? Number(formData.enableFreeDelivery) : 0,
            freeDeliveryMinAmount: formData.freeDeliveryMinAmount !== undefined ? Number(formData.freeDeliveryMinAmount) : 0,
            feeType: 'FLAT',
            feeLabel: JSON.stringify({ 'en-SA': formData.feelabelen, 'ar-SA': formData.feelabelar }),
            feeValue: Number(formData.feevalue),
            errorMsg: JSON.stringify({ 'en-SA': formData.errormsgen, 'ar-SA': formData.errormsgar }),
            country: formData.countryname,
            minCartTotal: Number(formData.minpayment),
            maxCartTotal: Number(formData.maxpayment),
            lastUpdatedBy: getSessionId()
        };
    };
    const createEditPayload = () => {
        return {
            id: props.formData && props.formData.id ? props.formData.id : undefined,
            channelId: props.channelId,
            enablePaymentFee: formData.enablePaymentFee,
            feeType: formData.feetype,
            enableFreeDelivery: formData.enableFreeDelivery !== undefined ? Number(formData.enableFreeDelivery) : 0,
            freeDeliveryMinAmount: formData.freeDeliveryMinAmount !== undefined ? Number(formData.freeDeliveryMinAmount) : 0,
            feeLabel: JSON.stringify({ "en-SA": formData.feelabelen, "ar-SA": formData.feelabelar }),
            feeValue: Number(formData.feevalue),
            errorMsg: JSON.stringify({ "en-SA": formData.errormsgen, "ar-SA": formData.errormsgar }),
            country: formData.countryname,
            minCartTotal: Number(formData.minpayment),
            maxCartTotal: Number(formData.maxpayment),
        };
    };
    const submitForm = (event) => {
        event.preventDefault();
        if (validateForm()) {
            if (!props.isEditMode) {
                const savePayload = createSavePayload();
                console.log("tamarapayload", savePayload);
                axios.post(`${legolasApi.url}/admin/payment/config/save`, savePayload).then((res) => {
                    console.log('codsave', res);
                    if (res.data.success) {
                        props.handleSuccessMsg();
                        setErrormsg(errorField);
                        setFormData(formField);
                        props.refreshPaymentMethod(0);
                        props.getListData(props.channelId);
                    }
                }).catch((error) => {
                    props.handleErrorMsg(error.response.data.error);
                    console.log('Error in save configuration ', error.response.data.error)
                });
            } else {
                const editPayload = createEditPayload();
                axios.post(`${legolasApi.url}/admin/payment/config/update`, editPayload).then((res) => {
                    console.log('codedit', res.data.success);
                    if (res.data.success) {
                        props.handleEditSuccessMsg();
                        setFormData(formField);
                        props.refreshPaymentMethod(0);
                        props.getListData(props.channelId);
                    }
                }).catch((error) => {
                    props.handleErrorMsg(error.response.data.error);
                    console.log('Error in edit configuration ', error.response.data.error);
                });
            }
        }
        else {
            return null;
        }
    };
    const address = () => {
        axios.get(`${elrondApi.url}/hnak/locationdata/${elrondApi.source}`).then(res => {
            const country = res.data.data
            setCountryList(country)
        }).catch((error) => {
            console.log("Error in load address data", error);
        })
    };
    React.useEffect(() => {
        address();
        setFormData(props.formData ? props.formData : {});
    }, [props.isEditMode && props.paymentMethod && props.formData.countryname]);

    return (
        <>
            <Box sx={{ bottom: '20%', marginLeft: '10%', width: '80%' }}>
                <form onSubmit={submitForm}>
                    {console.log("rturndata", props.formData)}
                    <Grid container spacing={2} columns={12} >
                        <Grid item xs={6} sx={{ display: 'flex' }}>
                            <Box sx={{ width: '400px', height: 'auto' }}>
                                <Typography sx={inputlabelstyle}>Enable Next Day Delivery
                                    <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.enablePaymentFee && !formData.enablePaymentFee ? '*' : ''}</span>
                                    {errormsg.enablePaymentFee && !formData.enablePaymentFee && (<span style={{ color: 'red' }}>[Required]</span>)}
                                </Typography>
                                <Box >
                                    <Controller
                                        name='enablePaymentFee'
                                        control={control}
                                        rules={{ required: 'Payment Fee is required' }}
                                        render={({ field }) =>
                                            <Select
                                                name='enablePaymentFee'
                                                value={`${formData.enablePaymentFee}`}
                                                label='Enable-Tamara'
                                                sx={{ width: '395px', borderRadius: '0px', border: '1px solid #000', marginLeft: '5px' }}
                                                onChange={handlechange}
                                            >
                                                <MenuItem value={1}>Yes</MenuItem>
                                                <MenuItem value={0}>No</MenuItem>
                                            </Select>
                                        }
                                        type='number'
                                    />
                                </Box>
                                {/* <Typography sx={inputlabelstyle}>Fee Label (in English)
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.feelabelen && !formData.feelabelen ? '*' : ''}</span>

                                        {errormsg.feelabelen && !formData.feelabelen && (<span style={{ color: 'red' }}>[Required]</span>)}

                                    </Typography>
                                    <Box>
                                        <Controller
                                            name="feelabelen"
                                            control={control}
                                            rules={{ required: 'Fee Label en-SA is required' }}
                                            render={({ field }) => (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text" id="basic-addon2" style={{ borderRadius: 'none', height: '47px', marginTop: '10px', backgroundColor: "" }} >en-SA</span>
                                                    </div>
                                                    <TextField
                                                        {...field}
                                                        label="Fee Label en-SA"
                                                        aria-describedby="basic-addon2"
                                                        sx={{ flexGrow: 1 }}
                                                        // value={`${formData.feelabelen}`}
                                                        value= {formData.feelabelen ? formData.feelabelen : null}
                                                        onChange={handlechange}
                                                    />

                                                </div>
                                            )}
                                        />
                                    </Box>
                                    <Typography sx={inputlabelstyle}>Fee Value
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.feevalue && !formData.feevalue ? '*' : ''}</span>

                                        {errormsg.feevalue && !formData.feevalue && (<span style={{ color: 'red' }}>[Required]</span>)}

                                    </Typography>
                                    <Box >
                                        <Controller
                                            name='feevalue'
                                            control={control}
                                            rules={{ required: 'Fee Value is required' }}
                                            render={({ field }) => <TextField {...field} label='Fee Value' 
                                            // value={`${formData.feevalue}`}
                                            value= {formData.feevalue !== null ? formData.feevalue : ''}
                                            defaultValue={formData.feevalue}
                                            onChange={handlechange} fullWidth />}
                                        />

                                    </Box>
                                    <Typography sx={inputlabelstyle}>Min Allowed Payment
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.minpayment && !formData.minpayment ? '*' : ''}</span>
                                        {errormsg.minpayment && !formData.minpayment && (<span style={{ color: 'red' }}>[Required]</span>)}

                                    </Typography>
                                    <Box >
                                        <Controller
                                            name='minpayment'
                                            control={control}
                                            rules={{ required: 'Min Allowed Payment is required' }}
                                            render={({ field }) => <TextField {...field} label='Min Allowed Payment' 
                                            value= {formData.minpayment ? formData.minpayment : null}
                                            onChange={handlechange}
                                            fullWidth />}
                                        />

                                    </Box>
                                    <Typography sx={inputlabelstyle}>Error Message (in English)
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.errormsgen && !formData.errormsgen ? '*' : ''}</span>

                                        {errormsg.errormsgen && !formData.errormsgen && (<span style={{ color: 'red' }}>[Required]</span>)}

                                    </Typography>
                                    <Box>
                                        <Controller
                                            name="errormsgen"
                                            control={control}
                                            rules={{ required: 'Error Message en-SA is required' }}
                                            render={({ field }) => (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text" id="basic-addon2" style={{ borderRadius: 'none', height: '47px', marginTop: '10px', backgroundColor: "" }} >ar-SA</span>
                                                    </div>
                                                    <TextField
                                                        {...field}
                                                        label="error message en"
                                                        aria-describedby="basic-addon2"
                                                        sx={{flexGrow: 1}}
                                                        value= {formData.errormsgen ? formData.errormsgen : null}
                                                        onChange={handlechange}
                                                    />

                                                </div>
                                            )}
                                        />
                                    </Box> */}
                            </Box>
                        </Grid>
                        {/* <Grid item xs={6} >
                                <Box sx={{ width: '400px' }}>
                                    <Typography sx={inputlabelstyle}>Fee Type
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.feetype && !formData.feetype ? '*' : ''}</span>
                                        {errormsg.feetype && !formData.feetype && (<span style={{ color: 'red' }}>[Required]</span>)}
                                    </Typography>
                                    <Box >
                                        <Controller
                                            name='feetype'
                                            control={control}
                                            rules={{ required: 'Fee Type is required' }}
                                            render={({ field }) =>
                                                <Select
                                                    name='feetype'
                                                    onChange={handlechange}
                                                    label='Enable-Tamara'
                                                    value={'FLAT'}
                                                    disabled={true}
                                                    sx={{ width: '395px', borderRadius: '0px', border: '1px solid #000', marginLeft: '5px' }}
                                                >
                                                    <MenuItem value={'PERCENTAGE'}>Percentage</MenuItem>
                                                    <MenuItem value={'FLAT'}>Flat</MenuItem>
                                                </Select>
                                            }
                                        />
                                    </Box>
                                    <Typography sx={inputlabelstyle}>Fee Label (in Arabic)
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.feelabelar && !formData.feelabelar ? '*' : ''}</span>
                                        {errormsg.feelabelar && !formData.feelabelar && (<span style={{ color: 'red' }}>[Required]</span>)}
                                    </Typography>

                                    <Box>
                                        <Controller
                                            name="feelabelar"
                                            control={control}
                                            render={({ field }) => (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text" id="basic-addon2" style={{ borderRadius: 'none', height: '47px', marginTop: '10px', backgroundColor: "" }} >ar-SA</span>
                                                    </div>
                                                    <TextField
                                                        {...field}
                                                        // value={`${formData.feelabelar}`}
                                                        value= {formData.feelabelar ? formData.feelabelar : null}
                                                        label="Fee Label ar-SA"
                                                        aria-describedby="basic-addon2"
                                                        sx={{ flexGrow: 1 }}
                                                        onChange={handlechange}
                                                    />
                                                </div>
                                            )}
                                        />

                                    </Box>
                                    <Typography sx={inputlabelstyle}>Country Name
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.countryname && !formData.countryname ? '*' : ''}</span>
                                        {errormsg.countryname && !formData.countryname && (<span style={{ color: 'red' }}>[Required]</span>)}
                                    </Typography>
                                    <Box >
                                        <Controller
                                            name='countryname'
                                            control={control}
                                            rules={{ required: 'Country Name is required' }}
                                            render={({ field }) =>
                                                <Select
                                                    name='countryname'
                                                    label='CountryName'
                                                    onChange={handlechange}
                                                    // value={formData.countryname}
                                                    value= {formData.countryname ? formData.countryname : null}
                                                    // value={`${formData.countryname}`}
                                                    sx={{ width: '395px', borderRadius: '0px', border: '1px solid #000', marginLeft: '5px' }}
                                                >
                                                    {
                                                        countryList.map(country => {

                                                            return (
                                                                <MenuItem value={country.id}>{country.value}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            }
                                            type='number'
                                        />

                                    </Box>
                                    <Typography sx={inputlabelstyle}>Max Allowed Payment
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.maxpayment && !formData.maxpayment ? '*' : ''}</span>
                                        {errormsg.maxpayment && !formData.maxpayment && (<span style={{ color: 'red' }}>[Required]</span>)}
                                    </Typography>
                                    <Box >
                                        <Controller
                                            name='maxpayment'
                                            control={control}
                                            rules={{ required: 'Max Allowed Payment is required' }}
                                            render={({ field }) => <TextField {...field} label='Max Allowed Payment' 
                                            onChange={handlechange} 
                                            // value={`${formData.maxpayment}`}
                                            value= {formData.maxpayment ? formData.maxpayment : null}
                                            fullWidth
                                            />} 
                                        />

                                    </Box>
                                    <Typography sx={inputlabelstyle}>Error Message (in Arabic)
                                        <span style={{ color: 'red', marginRight: '15px' }}>{errormsg.errormsgar && !formData.errormsgar ? '*' : ''}</span>
                                        {errormsg.errormsgar && !formData.errormsgar && (<span style={{ color: 'red' }}>[Required]</span>)}
                                    </Typography>
                                    <Box>
                                        <Controller
                                            name="errormsgar"
                                            control={control}
                                            rules={{ required: 'Error Message ar-SA is required' }}
                                            render={({ field }) => (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-append">
                                                        <span className="input-group-text" id="basic-addon2" style={{ borderRadius: 'none', height: '47px', marginTop: '10px', backgroundColor: "" }} >ar-SA</span>
                                                    </div>
                                                    <TextField
                                                        {...field}
                                                        label="error message ar"
                                                        aria-describedby="basic-addon2"
                                                        sx={{ flexGrow: 1 }}
                                                        // value={`${formData.errormsgar}`}
                                                        value= {formData.errormsgar ? formData.errormsgar : null}
                                                        onChange={handlechange}
                                                    />

                                                </div>
                                            )}
                                        />
                                    </Box>
                                </Box>
                            </Grid> */}
                        <Box sx={{ marginLeft: '85%' }}>
                            <BottomNavigation
                                showLabels
                                sx={{
                                    '& .MuiBottomNavigationAction-root': {
                                        backgroundColor: globalStyles.colors.white,
                                        alignItems: 'center',
                                        border: '2px solid #2b3f7a !important',
                                        color: '#2b3f7a',
                                        margin: '5px 10px !important',
                                        padding: '0 !important',
                                        fontSize: '0.9rem !important',
                                        '&:hover': {
                                            transform: 'scale(1.1, 1.1)'
                                        },
                                        '& .Mui-selected': {
                                            color: '#2b3f7a',
                                            transition: 'none',
                                            fontSize: '0.9rem'
                                        }
                                    }
                                }}
                            >
                                <BottomNavigationAction type="submit" label="Save Config"
                                    sx={{
                                        backgroundColor: '#2b3f7a !important',
                                        border: '2px solid #2b3f7a !important',
                                        color: '#fff !important',
                                        '& .Mui-selected': {
                                            color: '#fff !important'
                                        }
                                    }}
                                />
                            </BottomNavigation>
                        </Box>

                    </Grid>
                </form>

            </Box>

        </>)
}

export default NextdayConfiguration;